import React, { useRef, useEffect, useState } from "react";
import io from "socket.io-client";
import { useNavigate } from "react-router-dom";
import { NicknameContext } from "../App";
import { useContext } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Form,
  Button,
  Spinner,
  Modal,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Figure } from "react-bootstrap";
import { RoomContext } from "../App";
import { Card } from "react-bootstrap";
import { socket } from "../App";
import { Carousel } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import Textarea from "@mui/joy/Textarea";
import { browserHistory } from "react-router-dom";
import { ListGroup } from "react-bootstrap";
import igorBic3 from "../igorBic3.jpg";
import exampleofGood from "../exampleofGood.png";

import igor5 from "../igor5.png"
import { TransitionGroup, CSSTransition } from 'react-transition-group';



export const Game = ({ setInRoom, setRoom, setGameStarted }) => {
  const [text, setText] = useState("");
  const [waiting, setWaiting] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();
  const { nickname_GLOBAL } = useContext(NicknameContext);

  const { room } = useContext(RoomContext);
  const nickname = nickname_GLOBAL;
  const [cartoon, setCartoon] = useState([]);

  // const [cartoon, setCartoon] = useState([]);
  const [playerTurn, setPlayerTurn] = useState(0);

  const [gameEnd, setGameEnd] = useState(false);

  const [rounds, setRounds] = useState(0);

  const [cartoonId, setCartoonId] = useState(null);

  const [user] = useAuthState(auth);

  const [image, setImage] = useState(null);

  const [imagesReceived, setImagesReceived] = useState([]);

  const [extensions, setExtensions] = useState([]);

  const [finalImage, setFinalImage] = useState(null);

  const [error,setError] = useState(null)

  useEffect(() => {
   // console.log(room);
   // console.log(nickname);
    if (!room) {
      navigate("/");
    } else {
      socket.emit("round_req", { room, nickname });
      socket.emit("get_first_img", { room });
    }

    socket.on("final_image", (data) => {
      if (data.message) {
        setWaiting(false)
        setError(true)
        setFinalImage("fail")
      } else {
        setFinalImage(data.url);
        setWaiting(false)
      }
    })

    socket.on("disconnect", (r) => {
      //console.log("DISCO", r);
    });

    socket.on("round_res", (data) => {
    //  console.log("d", data);
      setCartoon(data.cartoon.scenes);
      setCartoonId(data.cartoon.id);

      // setRounds(data.cartoon.length)
      setRounds((rounds) => rounds + 1);
      setPlayerTurn(data.playerTurn == nickname);
      setWaiting(false);
    });

    socket.on("done", () => {
     // console.log("done");
      setDone(true);
    });
    socket.on("game_end", () => {
    //  console.log("game_end");
      setGameEnd(true);
      //navigate("/results");
    });

    return () => {
      socket.off("round_res");
      socket.off("round_req");
      socket.off("game_end");
      socket.off("images");
      socket.off("image_response");

      socket.emit("disconnect_", { room: room, nickname: nickname });
      setRoom("");
      setGameStarted(false);
      console.log("unmount");
      //  alert("unmount")
    };
  }, []);

  const handleReady_ = (e) => {
    e.preventDefault();

    //trRef.current.nodes([]);
    //const dataUrl = stageRef.current.toDataURL();
  //  console.log(dataUrl);

  /*  socket.emit("image_request", {
      room: room,
      dataUrl: dataUrl,
      prompt: text || "the man is walking",
    });*/

    setWaiting(true);
  };

  const handleOk = (e) => {
    e.preventDefault();
    //console.log("img rec", imagesReceived);

    socket.emit("image_accepted", {
      room: room,
      nickname: nickname,
      url: imagesReceived[0],
      prompt: text,
    });
    setImagesReceived([]);
    setText("");
    // then display the extensions in a row, including the new image
  };

  const quit = () => {
    // socket.emit("disconnect_", { room: room, nickname: nickname });
    setInRoom(false);
    setFinalImage(null);
    setRoom("")
    setError("")
  };

  const fileInputRef = useRef();



  const handleSubmit = (e) => {
    e.preventDefault();

   // console.log(fileInputRef?.current.files[0]);
    const file = fileInputRef?.current.files[0];
    const type = file?.type.split('/')[1];

    setWaiting(true)
    socket.emit("image_selected", {
      room: room,
      nickname: nickname,
      imgUrl: file,
      type: type
    });
  }

  return (
    <>

{!waiting && !finalImage && 
<Form onSubmit={handleSubmit}>
   <Form.Group controlId="formFile" className="mb-3 mt-3" style={{textAlign:"left"}}>
    <h3>Multiplayer mode</h3>
        <Form.Label style={{textAlign:"left"}}>Upload a photo for fusion</Form.Label>
        <div>
          <strong>Tip:</strong> Try to find funny/cool images (e.g landscapes, album covers, memes, iconic images, etc) on your camera roll. (that are not personal)</div>
          
        <Form.Control type="file" ref={fileInputRef}/>
        </Form.Group>
        <Button type="submit">Ready</Button>
        </Form>
}
      {waiting && (
        <>
        Fusing..
        <br/>
        (usually takes 10-20 seconds)
        </>
      )}
      {!waiting && finalImage && !error && (
        <>
        <h3>Result!</h3>
        <Image src={finalImage} size="md" fluid />
        <Button onClick={quit}>Lobby</Button>
        </>
      )}
      {!waiting && finalImage && error && (
        <>
        <div>There was an error creating the final image :(</div>
          <div>(This can happen if the input images contain celebrities)</div>
        <Button onClick={quit}>Try again</Button>
        </>
        )}
    </>
  );
};

/*
   <Form style={{display:"flex",flexDirection:"column",alignItems:"start"}}>
        {playerTurn ? (
        <><Form.Group controlId="formBasicText" style={{textAlign:"left"}}>
          <Form.Label >What happens next?</Form.Label>
          <Form.Control type="text" as="textarea" placeholder="Enter text" onChange={(e) => setText(e.target.value)} />
        </Form.Group>

        <Button className="mt-3" variant="primary" type="submit" rows={3} onClick={handleReady} disabled={isLoading}>
          Submit
        </Button>
        </>) : (<div>Other player's turn...</div>)}

      </Form>
*/
